import { useMemo } from 'react';

// Subtle drifting light particles (embers) for extra cinematic atmosphere
// over dark hero/video sections. Pure CSS animation — no per-frame JS cost.
export const ParticleField = ({ count = 16, className = '' }) => {
  const particles = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: 2 + Math.random() * 2.5,
        duration: 11 + Math.random() * 9,
        delay: Math.random() * 10,
        drift: -20 + Math.random() * 40,
      })),
    [count]
  );

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true" data-testid="particle-field">
      {particles.map((p) => (
        <span
          key={p.id}
          className="absolute rounded-full bg-[hsl(var(--lxra-gold))] lxra-particle"
          style={{
            left: `${p.left}%`,
            bottom: '-10px',
            width: p.size,
            height: p.size,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            '--lxra-particle-drift': `${p.drift}px`,
          }}
        />
      ))}
    </div>
  );
};
